  "use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
import pauseAutoplayOffscreen from "@/utils/pauseAutoplayOffscreen";
import { useState, useEffect } from "react";
import Link from "next/link";
import Title from "./Title";
import { ArrowRight } from "lucide-react";

// Rich Text helper for Strapi Blocks
const renderRichText = (blocks) => {
  if (typeof blocks === 'string') return blocks;
  if (Array.isArray(blocks)) {
    return blocks.map(block => {
      if (block.type === 'paragraph') {
        return block.children.map(child => child.text).join('');
      }
      return '';
    }).join('\n');
  }
  return '';
};
const truncateWords = (text, maxWords = 20) => {
  if (!text) return "";

  const words = text.trim().split(/\s+/);
  return words.length > maxWords
    ? words.slice(0, maxWords).join(" ") + "..."
    : text;
};
const BlogList = ({ data, sectionData }) => {
  // Use data directly to support SSR/SEO. Showing latest blogs is better than random.
  const displayBlogs = Array.isArray(data) ? data : [];

  const sectionTitle = sectionData?.Title || "Explore Our Blogs";
  const sectionDescription = renderRichText(sectionData?.Description) || "Explore stories, ideas, and perspectives from the heart of MSU, where education meets experience, and every skill tells a story.";

  return (
    <section className="w-full top_bottom_space">
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        <div className="w-full heading_space_bottom">
          <Title
            heading={sectionTitle}
            subText={sectionDescription}
            color="text-black"
            subTextColor="text-black/70"
            align="text-left"
          />
        </div>
        <div className="w-full mx-auto">
          <Swiper
            onSwiper={pauseAutoplayOffscreen}
            modules={[Autoplay]}
            spaceBetween={16}
            slidesPerView={1.2}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              640: { slidesPerView: 1.5 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 2.5 },
              1280: { slidesPerView: 3 },
            }}
            className="blogs w-full"
          >
            {displayBlogs.map((item, index) => (
              <SwiperSlide key={index} className="pb-2">
                <div className="flex flex-col bg-white overflow-hidden transition duration-300">
                  <div className="relative w-full h-55 sm:h-65 md:h-68 lg:h-75  overflow-hidden">
                    <Image
                      src={item.cover?.formats?.small?.url || '/BlogCard_Thumbnail.webp'}
                      alt={item.title}
                      fill
                      className="object-coner w-full  h-55 sm:h-65 md:h-68 lg:h-75 transition-transform duration-500 hover:scale-110"
                    />
                  </div>

                  <span className="text-xs font-bold bg-[#FFF0D7] text-[#EB9100] px-2 py-1 uppercase w-fit mt-4">
                    {item.category?.name}
                  </span>
                  <Link
                    href={`/blog/${item.slug}`}
                    className="pt-3 flex flex-col gap-2"
                  >
                    <p className="line-clamp-2 text-[18px] lg:text-[20px] font-bold text-gray-900 leading-snug hover:text-[#EB9100] cursor-pointer min-h-14">
                     {truncateWords(item.title, 15)}
                    </p>
                  </Link>
                  <p className="text-[16px] lg:text-[18px] text-gray-600 line-clamp-2">
                    {truncateWords(item.description, 15)}
                  </p>

                  <hr className="mt-2 border-t border-[#616777]/20 border w-full" />

                  <div className="flex items-center text-[clamp(10px,9.5vw,12px)] md:text-[13px] text-gray-500 gap-3">
                    <span>{item.author?.name}</span>

                    <span className="flex items-center gap-1">
                      <span className="text-[20px] font-bold">·</span>
                      {new Date(item.blogDate).toDateString()}
                    </span>

                    <span className="flex items-center gap-1">
                      <span className="text-[20px] font-bold">·</span>2 min
                    </span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="w-full flex justify-center mt-10">
            <Link
              href={"/blog"}
              className="cursor-pointer flex items-center gap-2 text-[16px] font-semibold text-black"
            >
              <span className="text-lg">Discover All Blogs</span>
              <div className="bg-black text-white text-lg p-1 transition flex items-center justify-center">
                <ArrowRight size={20} />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogList;
